import { render, staticRenderFns } from "./tcp_info.vue?vue&type=template&id=31235f22&scoped=true"
import script from "./tcp_info.vue?vue&type=script&lang=js"
export * from "./tcp_info.vue?vue&type=script&lang=js"
import style0 from "./tcp_info.vue?vue&type=style&index=0&id=31235f22&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31235f22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31235f22')) {
      api.createRecord('31235f22', component.options)
    } else {
      api.reload('31235f22', component.options)
    }
    module.hot.accept("./tcp_info.vue?vue&type=template&id=31235f22&scoped=true", function () {
      api.rerender('31235f22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appManage/tcp_info.vue"
export default component.exports